/*
# -----------------------------------------------------------------------------
#	Project: HSE Genius®
#	Client ID: 834215
#	Registration Code: IT-2025-ZR319-MQ744
#	Author: KaimakiWeb
#	Website: https://kaimakiweb.com
#	Copyright (c) 2024-2026 Kaimaki Web. All rights reserved.
#
#	This software and its source code are the property of KaimakiWeb.
#	Unauthorized copying, modification, distribution, or use of this software,
#	via any medium, is strictly prohibited unless prior written permission
#	is obtained from KaimakiWeb.
# -----------------------------------------------------------------------------
*/

export const SIGN_IN_REQUEST = "SIGN_IN_REQUEST";
export const SIGN_IN_SUCCESS = "SIGN_IN_SUCCESS";
export const SIGN_IN_FAILURE = "SIGN_IN_FAILURE";

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const GET_COUNTS_REQUEST = "GET_COUNTS_REQUEST";
export const GET_COUNTS_SUCCESS = "GET_COUNTS_SUCCESS";
export const GET_COUNTS_FAILURE = "GET_COUNTS_FAILURE";

export const GET_HP_REQUEST = "GET_HP_REQUEST";
export const GET_HP_SUCCESS = "GET_HP_SUCCESS";
export const GET_HP_FAILURE = "GET_HP_FAILURE";

export const GET_PROFILE = "GET_PROFILE";
export const GET_COMPANY = "GET_COMPANY";
export const PROFILE_DATA = "PROFILE_DATA";
export const COMPANY_DATA = "COMPANY_DATA";

export const MFA_PENDING = "MFA_PENDING";
export const MFA_COMPLETE = "MFA_COMPLETE";
